webpackJsonp([25],{

/***/ "+x1M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n  query PageHomeQuery($lang: String!) {\n    menu(lang: $lang, _id: \"primary\") {\n      items {\n        title\n        path\n        rewrite_url\n        rewrite_source\n        rewrite_target\n      }\n    }\n    searchLapa: page(lang: $lang, _id: 3660) {\n      path\n    }\n\n    # aktuali(lang: $lang) {\n    #   title\n    #   date_created\n    #   images {\n    #     src\n    #     alt\n    #     thumb(size: \"card-default\") {\n    #       url\n    #       retina\n    #       width\n    #       height\n    #     }\n    #   }\n    #   path\n    #   acf\n    #   post_type\n    #   template\n    #   rewrite_url\n    #   rewrite_source\n    #   rewrite_target\n    # }\n\n    saites(lang: $lang) {\n      aktuali {\n        menu_order\n        path\n        target\n        title\n      }\n      noderigi {\n        menu_order\n        path\n        target\n        title\n      }\n      temas {\n        menu_order\n        path\n        target\n        title\n      }\n    }\n\n    parpilsetu(lang: $lang) {\n      title\n      path\n      images {\n        thumb(size: \"card-cover\") {\n          url\n        }\n      }\n      post_type\n      template\n      rewrite_url\n      rewrite_source\n      rewrite_target\n    }\n    jaunumi(lang: $lang, perpage: 6, page: 0) {\n      posts {\n        path\n        title\n        date_created\n        post_type\n        template\n      }\n    }\n    jaunumiLapa: page(lang: $lang, _id: 1516) {\n      path\n    }\n    video_galerija(lang: $lang) {\n      title\n      path\n      post_type\n      template\n      images {\n        thumb(size: \"card-video\") {\n          url\n        }\n      }\n      acf\n    }\n    noderigi(lang: $lang) {\n      nosaukums\n      ikona\n      post {\n        path\n        rewrite_url\n        rewrite_source\n        rewrite_target\n      }\n    }\n    teksti(\n      lang: $lang\n      _id: [\n        \"sazinaties\"\n        \"par_pilsetu\"\n        \"jaunakas_zinas\"\n        \"skatit_vairak_jaunumus\"\n        \"video_galerija\"\n        \"atskanot_video\"\n        \"aizvert\"\n        \"sazinas_forma\"\n        \"sazinas_forma_apraksts\"\n        \"vards\"\n        \"uzvards\"\n        \"kluda\"\n        \"noradiet_precizu_informaciju\"\n        \"tavs_e_pasts\"\n        \"talrunis\"\n        \"zina\"\n        \"tava_zina\"\n        \"obligatie_lauki\"\n        \"jus_varat_pievienot_failu_sados_formatos\"\n        \"pievienot_failu\"\n        \"nosutit\"\n        \"procesa\"\n        \"paldies_zina_sanemta!\"\n        \"pec_briza_pamegini_velreiz\"\n        \"notikusi_kluda!\"\n        \"labi\"\n        \"meklet_lapas_satura\"\n        \"es_mekleju\"\n        \"aktuali\"\n        \"noderigi\"\n        \"temas\"\n        \"atvert\"\n      ]\n    ) {\n      _id\n      text\n    }\n  }\n"], ["\n  query PageHomeQuery($lang: String!) {\n    menu(lang: $lang, _id: \"primary\") {\n      items {\n        title\n        path\n        rewrite_url\n        rewrite_source\n        rewrite_target\n      }\n    }\n    searchLapa: page(lang: $lang, _id: 3660) {\n      path\n    }\n\n    # aktuali(lang: $lang) {\n    #   title\n    #   date_created\n    #   images {\n    #     src\n    #     alt\n    #     thumb(size: \"card-default\") {\n    #       url\n    #       retina\n    #       width\n    #       height\n    #     }\n    #   }\n    #   path\n    #   acf\n    #   post_type\n    #   template\n    #   rewrite_url\n    #   rewrite_source\n    #   rewrite_target\n    # }\n\n    saites(lang: $lang) {\n      aktuali {\n        menu_order\n        path\n        target\n        title\n      }\n      noderigi {\n        menu_order\n        path\n        target\n        title\n      }\n      temas {\n        menu_order\n        path\n        target\n        title\n      }\n    }\n\n    parpilsetu(lang: $lang) {\n      title\n      path\n      images {\n        thumb(size: \"card-cover\") {\n          url\n        }\n      }\n      post_type\n      template\n      rewrite_url\n      rewrite_source\n      rewrite_target\n    }\n    jaunumi(lang: $lang, perpage: 6, page: 0) {\n      posts {\n        path\n        title\n        date_created\n        post_type\n        template\n      }\n    }\n    jaunumiLapa: page(lang: $lang, _id: 1516) {\n      path\n    }\n    video_galerija(lang: $lang) {\n      title\n      path\n      post_type\n      template\n      images {\n        thumb(size: \"card-video\") {\n          url\n        }\n      }\n      acf\n    }\n    noderigi(lang: $lang) {\n      nosaukums\n      ikona\n      post {\n        path\n        rewrite_url\n        rewrite_source\n        rewrite_target\n      }\n    }\n    teksti(\n      lang: $lang\n      _id: [\n        \"sazinaties\"\n        \"par_pilsetu\"\n        \"jaunakas_zinas\"\n        \"skatit_vairak_jaunumus\"\n        \"video_galerija\"\n        \"atskanot_video\"\n        \"aizvert\"\n        \"sazinas_forma\"\n        \"sazinas_forma_apraksts\"\n        \"vards\"\n        \"uzvards\"\n        \"kluda\"\n        \"noradiet_precizu_informaciju\"\n        \"tavs_e_pasts\"\n        \"talrunis\"\n        \"zina\"\n        \"tava_zina\"\n        \"obligatie_lauki\"\n        \"jus_varat_pievienot_failu_sados_formatos\"\n        \"pievienot_failu\"\n        \"nosutit\"\n        \"procesa\"\n        \"paldies_zina_sanemta!\"\n        \"pec_briza_pamegini_velreiz\"\n        \"notikusi_kluda!\"\n        \"labi\"\n        \"meklet_lapas_satura\"\n        \"es_mekleju\"\n        \"aktuali\"\n        \"noderigi\"\n        \"temas\"\n        \"atvert\"\n      ]\n    ) {\n      _id\n      text\n    }\n  }\n"]);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactApollo = __webpack_require__("3zLD");

var _graphqlTag = __webpack_require__("tlQw");

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _pages = __webpack_require__("04qB");

var _reactRedux = __webpack_require__("RH2O");

var _LoadingActions = __webpack_require__("tuf/");

var _LoadingActions2 = _interopRequireDefault(_LoadingActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var QUERY = (0, _graphqlTag2.default)(_templateObject);

var queryOptions = {
  options: function options(_ref) {
    var lang = _ref.lang,
        postId = _ref.postId,
        init_page = _ref.init_page;
    return {
      /* FIXME: Cache ir pie vainas, ka teksti, iespējams arī citas
      daļas mēdz neatjaunoties, jo dati tiek uzskatīti par identiskiem */
      fetchPolicy: "cache-first",
      variables: {
        postId: init_page.rewrite_id ? init_page.rewrite_id : postId,
        lang: lang || "lv"
      }
    };
  },
  props: function props(_props) {
    var _props$data = _props.data,
        loading = _props$data.loading,
        lang = _props$data.variables.lang,
        page = _props$data.page,
        menu = _props$data.menu,
        searchLapa = _props$data.searchLapa,
        saites = _props$data.saites,
        parpilsetu = _props$data.parpilsetu,
        noderigi = _props$data.noderigi,
        jaunumi = _props$data.jaunumi,
        jaunumiLapa = _props$data.jaunumiLapa,
        video_galerija = _props$data.video_galerija,
        teksti = _props$data.teksti,
        rest = _objectWithoutProperties(_props$data, ["loading", "variables", "page", "menu", "searchLapa", "saites", "parpilsetu", "noderigi", "jaunumi", "jaunumiLapa", "video_galerija", "teksti"]);

    return {
      loading: loading,
      data: {
        page: [_props.ownProps.init_page],
        menu: menu,
        searchLapa: searchLapa,
        // aktuali,
        saites: saites,
        parpilsetu: parpilsetu,
        noderigi: noderigi,
        jaunumi: jaunumi,
        jaunumiLapa: jaunumiLapa,
        video_galerija: video_galerija,
        teksti: teksti,
        lang: lang
      }
    };
  }
};

var PageHome = function (_React$PureComponent) {
  _inherits(PageHome, _React$PureComponent);

  function PageHome() {
    _classCallCheck(this, PageHome);

    return _possibleConstructorReturn(this, (PageHome.__proto__ || Object.getPrototypeOf(PageHome)).apply(this, arguments));
  }

  _createClass(PageHome, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      if (this.props.loading) {
        this.props.loadingStatuss({ _id: this.props.path + "__", loading: true });
      } else if (!this.props.loading && this.props.global_loading && this.props.global_loading[this.props.path + "__"] === true) {
        this.props.loadingStatuss({
          _id: this.props.path + "__",
          loading: false
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.loading && nextProps.global_loading[nextProps.path + "__"] === false) {
        nextProps.loadingStatuss({ _id: nextProps.path + "__", loading: true });
      } else if (!nextProps.loading && nextProps.global_loading[nextProps.path + "__"] === true) {
        nextProps.loadingStatuss({ _id: nextProps.path + "__", loading: false });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;

      if (props.loading) {
        return null;
      }

      return _react2.default.createElement(_pages.Sakums, { data: props.data });
    }
  }]);

  return PageHome;
}(_react2.default.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return (
    // console.log(state)
    {
      global_loading: state.global_loading
    }
  );
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    loadingStatuss: function loadingStatuss(LOADING) {
      dispatch((0, _LoadingActions2.default)(LOADING));
    }
  };
};

exports.default = (0, _reactApollo.compose)((0, _reactApollo.graphql)(QUERY, queryOptions), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(PageHome);

/***/ })

});


// WEBPACK FOOTER //
// PageHome.f777620e98ec64d897e4.js